import * as React from 'react';

import {
  UitkMessagingCard,
  UitkMessagingCardImageLayout,
  UitkMessagingCardMedia,
  UitkMessagingCardSection
} from 'uitk-react-messaging-cards';
import { UitkFigure, UitkFigureAspectRatioType, UitkImage } from 'uitk-react-images';
import { UitkText } from 'uitk-react-text';

import { useStores } from 'utility/hooks';
import { SuggestedFilterOfferAction } from './';
import {
  ActionType,
  FlightsImagePlacard,
  FlightsListDisplayFilterItemType,
  FlightsSuggestedFilterItem
} from 'types/shared';
import { FlightsFilterOptionType, FlightsListDisplayFilterOptionType } from 'types/search/sort-filter';

interface SuggestedFilterProps {
  offer: {
    suggestedFilterDetails: FlightsImagePlacard;
    suggestedFilter: FlightsSuggestedFilterItem;
  };
}

export const SuggestedFilterOffer = (props: SuggestedFilterProps) => {
  const { sortFilterStore } = useStores();
  const { suggestedFilterDetails, suggestedFilter } = props.offer;
  const { filterPresentation } = sortFilterStore;
  const options = filterPresentation && filterPresentation.options;

  const imageAditionalProps = {
    'aria-hidden': 'true'
  };

  return (
    <UitkMessagingCard
      imageLayout={UitkMessagingCardImageLayout.LEFT}
      className="all-b-margin-three"
      data-test-id="suggested-filter"
    >
      <UitkMessagingCardMedia>
        <UitkFigure ratio={UitkFigureAspectRatioType.R1_1}>
          <UitkImage src={suggestedFilterDetails.image.url} additionalProps={imageAditionalProps} />
        </UitkFigure>
      </UitkMessagingCardMedia>
      <UitkMessagingCardSection heading={suggestedFilterDetails.heading} headingLevel="h3">
        <UitkText size={300}>{suggestedFilterDetails.message}</UitkText>
        {options &&
          (options as FlightsFilterOptionType[]).map(filterOption => {
            const { items, type } = filterOption as FlightsListDisplayFilterOptionType;
            if (type === suggestedFilter.type) {
              return items.map((filterItem: FlightsListDisplayFilterItemType) => {
                return suggestedFilterDetails.actions.map((action: ActionType) => (
                  <SuggestedFilterOfferAction
                    key={`suggested-filter-${suggestedFilter.type}`}
                    action={action}
                    filterItem={filterItem}
                    suggestedFilter={suggestedFilter}
                  />
                ));
              });
            }
          })}
      </UitkMessagingCardSection>
    </UitkMessagingCard>
  );
};
